// Bridge entre le client API (lib pure) et le widget Vue de re-auth.
// Quand le back retourne 401 master key unavailable, on flip ce flag
// pour que MasterKeyDialog s'affiche et propose de reauthentifier sans
// perdre la session.

import { ref } from "vue";

export const needsMasterKeyReauth = ref<boolean>(false);

export function flagMasterKeyMissing(): void {
  needsMasterKeyReauth.value = true;
}

export function clearMasterKeyFlag(): void {
  needsMasterKeyReauth.value = false;
}
